declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController } from '../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
//import { NgbAddNewPatient } from '../../../modal/addnewpatient.modal';
import { NgbCameraUploadModal } from '../profile/patientprofileview/personaldetailview/modal/cameraupload.modal';





@Component({
  selector: 'customerorders',
  templateUrl: './customerorders.component.html',
  styleUrls: [
    './customerorders.component.scss']
  , animations: [routerTransition()]
})

export class CustomerOrdersComponent implements OnInit {

  OnGoBack() {
    //alert("I cam bak");
    this.ShowList = true;
  }
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowRegister: boolean = true;
  public Showrow: boolean = true;
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
    public searchText: any;
  TodayDate = new Date();
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
    SelectedFromDate: NgbDateStruct;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "GG1O/577";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController();
  }
  RefreshPatients(st: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = "";
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 20;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = st;

    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetPatientInfoByFormattedCodeController();
  }
  _GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = null;
          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService) { }

  ngOnInit() {

    this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
    this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();

      this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.isNew = true;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.SelectedPatient.FormattedCode;
    this.LoadPatients();
    //this.GetPatientInfoByFormattedCodeController();

  }



  ShowList: boolean = true;

  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  //AddNewPatient() {

  //  const modalRef = this.modalService.open(NgbAddNewPatient,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;
    
  //  modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  //}
  CancelNewOperation() {

    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }

  SelectedPatient: PatientInfoByFormattedCodeController;
  ViewPatientDetails(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;

    if (patient != null) {



      this.ShowPatientDetails = true;
      this.ShowList = false;
      this.SelectedPatient = patient;
      this.Showarrow = true;
      this.Showrow = false;
      this.ShowRegister = false;
      //this.LoadPatientdetails()

    }
    else {
      this.ShowPatientDetails = false;
    }
  }
  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {


  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();

  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}

  criteriaChange(value: string) {
    this.RefreshPatients(value);


  }
    DecrementDate() {
        //this.dateI = new Date();
        //var i = this.dateI.valueOf() + 86400000;
        //this.dateI = new Date(i);
        //this.SelectedFromDate = dateI;
        //var ind: number = 0;
        //this.diff = this.diff - 1;
        //alert(this.diff);

        var monthNo = this.SelectedFromDate.month
        var d: Date = new Date(
            this.SelectedFromDate.year,
            monthNo - 1,
            this.SelectedFromDate.day
        );
        //this.parserFormatter.parse(this.SelectedFromDate).;

        d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
        //    d.getFullYear
        //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

        //  this.SelectedFromDate = this.SelectedFromDate.
        this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
        //this._GetBillDetailsInfoController();
        //ind++;
    }
    IncrementDate() {
        //this.dateI = new Date();
        //var i = this.dateI.valueOf() + 86400000;
        //this.dateI = new Date(i);
        //this.SelectedFromDate = dateI;
        //var ind: number = 0;
        //this.diff = this.diff - 1;
        //alert(this.diff);
        var monthNo = this.SelectedFromDate.month
        var d: Date = new Date(
            this.SelectedFromDate.year,
            monthNo - 1,
            this.SelectedFromDate.day
        );
        //this.parserFormatter.parse(this.SelectedFromDate).;

        d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
        //    d.getFullYear
        //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

        //  this.SelectedFromDate = this.SelectedFromDate.
        this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
        //this._GetBillDetailsInfoController();
        //ind++;
    }
  criteriaChange2(value: string) {
    this.RefreshPatients(value);


  }
  capture(l: PatientInfoByFormattedCodeController) {
    const modalRef = this.modalService.open(NgbCameraUploadModal,
      {
        centered: true,


      })
    modalRef.componentInstance.ActorCode = l.ActorCode;
    modalRef.componentInstance.Photo = l.Photo;
  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
    this.RefreshPatients(this.searchValue);
  }
    ViewOrder() {
        this.router.navigate(['/healins/vieworder']);
    }
  dataChanged(newobj) {

  }
  Payment() {

  }
  AddNewPatient() {

  }

}
